<template>
    <div>
        <!-- <b-alert variant="warning" show v-if="!comprometimento.saldoNaturezaOk"
            ><i class="fa fa-exclamation-triangle fa-lg"></i
            ><strong>
                O saldo da natureza de despesa do contrato é menor que o valor
                do comprometimento</strong
            ></b-alert
        > -->
        <b-row>
            <b-col>
                <div class="d-flex">
                    <btn-inserir-dotacao
                        class="pb-4"
                        v-if="valorDisponivel > 0 && operacao != 'D'"
                        :valorTotal="valorASerRateado"
                        :valorDisponivel="valorDisponivel"
                        :dataMovimento="dataMovimento"
                        @inserirRateio="$emit('inserirRateio', $event)"
                    ></btn-inserir-dotacao>
                    <!-- <btn-obter-dotacoes-processo
                        class="pb-4 ml-2"
                        v-if="valorDisponivel > 0 && operacao != 'D'"
                        :valorDisponivel="valorDisponivel"
                        :requisicao="requisicao"
                        @inserirRateio="$emit('inserirRateio', $event)"
                    ></btn-obter-dotacoes-processo> -->
                    <btn-obter-dotacoes-contrato
                        class="pb-4 ml-2"
                        v-if="valorDisponivel > 0 && operacao != 'D'"
                        :valorDisponivel="valorDisponivel"
                        :requisicao="requisicao"
                        @inserirRateio="$emit('inserirRateio', $event)"
                    ></btn-obter-dotacoes-contrato>
                </div>
            </b-col>
        </b-row>
        <rateios-tabela
            :rateios="rateios"
            :temAcoes="operacao != 'D'"
            :valorASerRateado="valorASerRateado"
            :valorDisponivel="valorDisponivel"
            :operacao="operacao"
            :dataMovimento="dataMovimento"
            @atualizarRateio="$emit('atualizarRateio', $event)"
            @excluirRateio="$emit('excluirRateio', $event)"
        >
            <template slot="botoes"> </template>
        </rateios-tabela>
    </div>
</template>

<script>
import RateiosTabela from './RateiosTabela'
import BtnInserirDotacao from './BtnInserirDotacao'
import BtnObterDotacoesProcesso from './BtnObterDotacoesProcesso'
import BtnObterDotacoesContrato from './BtnObterDotacoesContrato'

export default {
    components: {
        RateiosTabela,
        BtnInserirDotacao,
        BtnObterDotacoesProcesso,
        BtnObterDotacoesContrato
    },

    props: {
        rateios: {
            type: Array
        },

        valorASerRateado: {
            type: Number
        },

        valorDisponivel: {
            type: Number
        },

        operacao: {
            type: String
        },

        dataMovimento: {
            type: String
        },

        requisicao: {
            type: Object
        }
    },

    data() {
        return {
            erros: []
        }
    },

    methods: {},

    computed: {},

    watch: {},

    mounted() {}
}
</script>
